<template>
  <orders-base-view status="approval"></orders-base-view>
</template>

<script>

import OrdersBaseView from "@/components/orders/OrdersBaseView";
export default {
  name: 'OrdersApprovalView',

  components: {OrdersBaseView},
};
</script>
